import axios from "axios"
import {ExamPeriod} from "../types"

export const loadExamPeriods = async (authHeader: object): Promise<ExamPeriod[]> => {
    const response = await axios.get<ExamPeriod[]>("/api/eexam/periods", authHeader)
    return response.data
}

export const saveExamPeriod = async (data: Partial<ExamPeriod>, authHeader: object): Promise<ExamPeriod> => {
    if (data._id) {
        const response = await axios.put<ExamPeriod>(`/api/eexam/periods/${data._id}`, data, authHeader)
        return response.data
    }

    const response = await axios.post<ExamPeriod>("/api/eexam/periods", data, authHeader)
    return response.data
}

export const deleteExamPeriod = async (id: string, authHeader: object): Promise<void> => {
    await axios.delete(`/api/eexam/periods/${id}`, authHeader)
}
